var Transport = require('widgets-transport')();
var util = require('widgets-util');

var API = function(options) {
  this.options = options;
  this.transport = new Transport({ baseUrl: this.options.baseUrl });
};

API.prototype = {
    config: function(params, success) {
        params.widget_unique_id = this.options.id || this.options.widgetId || "";
        params.event_id = this.options.eventId || this.options.ingoId || "";
        params.widget_type = this.options.type || this.options.widget_type || this.options.widgetType || "";
        params.url = this.options.url || window.location.href || "";
        params.lang = this.options.lang || this.options.langId || "" ;
        params.version = this.options.version || "" ;
        var qs = util.queryString(params);
        this.transport.send({ url: (this.options.baseUrl || this.options.host || "") + '/api/v1/widget/config' + (qs ? '?' + qs : '') }, function(err, res) {
            if (err) throw err;
            success(JSON.parse(res));
        });
    }
};

module.exports = API;
